/** Name of the feature. */
export const SolanaSignTransaction = 'solana:signTransaction';
//# sourceMappingURL=signTransaction.js.map